namespace ui
{
	export namespace Form
	{
		export class BasicDateBasedInput
			extends Input
		{
			public readonly	FormatPattern: string;

			public constructor(
				value: string,
				format: string,
				descriptor: IBasicInputDescriptor,
				type: string,
				valueType: InputValueTypes
			)
			{
				super( value, descriptor, type, valueType );

				this.FormatPattern	= format;
			}

		}
	}
}
